import React from 'react';
import ReactDOM from 'react-dom';
import Area from '@evershop/evershop/src/components/common/Area';
import Hydrate from '@evershop/evershop/src/components/common/react/client/HydrateFrontStore';
Area.defaultProps.components = {
  'icon-wrapper': {
    f145c33d3a491a833c69c6577c6a01f2: {
      id: 'f145c33d3a491a833c69c6577c6a01f2',
      sortOrder: 5,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/catalog/pages/frontStore/all/SearchBox.jsx')
    },
    ec9c1bdcfd7999630c0e27947add36c7: {
      id: 'ec9c1bdcfd7999630c0e27947add36c7',
      sortOrder: 5,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/catalog/pages/frontStore/all/SearchBoxSm.jsx')
    },
    '125f8ba35b6af9b79e26c97d0ef0b83f': {
      id: '125f8ba35b6af9b79e26c97d0ef0b83f',
      sortOrder: 10,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/checkout/pages/frontStore/all/MiniCart.jsx')
    },
    '4c2436b1bb5343d308d32caf471deb1a': {
      id: '4c2436b1bb5343d308d32caf471deb1a',
      sortOrder: 30,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/customer/pages/frontStore/all/UserIcon.jsx')
    }
  },
  content: {
    e5456a81b45563176ec538cd356d202b: {
      id: 'e5456a81b45563176ec538cd356d202b',
      sortOrder: 0,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/all/Breadcrumb.jsx')
    },
    bdb0172166bca3ca550a050750f20b37: {
      id: 'bdb0172166bca3ca550a050750f20b37',
      sortOrder: 10,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/privacyPolicy/View.jsx')
    }
  },
  footer: {
    '0498430d6fd8f51f270ce2baf432e8b7': {
      id: '0498430d6fd8f51f270ce2baf432e8b7',
      sortOrder: 10,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/all/Footer.jsx')
    }
  },
  head: {
    aa0922d33ae719d95c4fefb87a118ec3: {
      id: 'aa0922d33ae719d95c4fefb87a118ec3',
      sortOrder: 5,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/all/HeadTags.jsx')
    },
    '34dfdcdfae2224e2824823c23061df9c': {
      id: '34dfdcdfae2224e2824823c23061df9c',
      sortOrder: 1,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/privacyPolicy/Meta.jsx')
    }
  },
  body: {
    '02615a78833e769f9ba526f8bc5a6787': {
      id: '02615a78833e769f9ba526f8bc5a6787',
      sortOrder: 1,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/all/Layout.jsx')
    },
    d127627ccf6d61979afc745a602ab95f: {
      id: 'd127627ccf6d61979afc745a602ab95f',
      sortOrder: 10,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/all/Notification.jsx')
    }
  },
  header: {
    bb2bc6900e53ff194dbf0696d5436045: {
      id: 'bb2bc6900e53ff194dbf0696d5436045',
      sortOrder: 10,
      component: require('/home/kickers/Kickers-Orders-ES/src/modules/cms/pages/frontStore/all/Logo.jsx')
    }
  },
  '*': {
    collection_products: {
      id: 'collection_products',
      sortOrder: 0,
      component: require('@evershop/evershop/src/components/frontStore/widgets/CollectionProducts.jsx')
    },
    text_block: {
      id: 'text_block',
      sortOrder: 0,
      component: require('@evershop/evershop/src/components/frontStore/widgets/TextBlock.jsx')
    },
    basic_menu: {
      id: 'basic_menu',
      sortOrder: 0,
      component: require('@evershop/evershop/src/components/frontStore/widgets/BasicMenu.jsx')
    },
    tidio_widget: {
      id: 'tidio_widget',
      sortOrder: 0,
      component: require('evershop_tidio_widget/components/widget/TidioWidget.jsx')
    }
  }
};
ReactDOM.hydrate(/*#__PURE__*/React.createElement(Hydrate, null), document.getElementById('app'));